import { BrowserRouter, Route, Routes } from "react-router-dom";
import React, { useState, useEffect } from "react";
// import "./App.css";
import Login from "./pages/Login/Login";
import Footer from "./components/common/Footer/Footer";
import SplashScreen from "./components/loader/SplashScreen/SplashScreen";
import Dashboard from "./pages/dashboard/Dashboard";
import Sidebar from "./components/common/Sidebar/Sidebar";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider } from "./Context/AuthProvider";
import LoginProtectedRoute from "./Routes/LoginProtectedRoute";
import CallRecords from "./pages/CallRecords/CallRecords";
import VPBXManagerMain from "./pages/VPBXManager/VPBXManagerMain";
import CreateIVR from "./pages/VPBXManager/IVRFlow/CreateIVR";
import NewRouting from "./pages/VPBXManager/Routing/NewRouting";
import NewForwarding from "./pages/VPBXManager/CallForwarding/NewForwarding";
import NewCallConferencing from "./pages/VPBXManager/CallConferencing/NewCallConferencing";
import NewExtensionsDetails from "./pages/VPBXManager/ExtensionsDetails/NewExtensionsDetails";
import NewListManager from "./pages/VPBXManager/ListManager/NewListManager";
import NewSoundSettings from "./pages/VPBXManager/SoundSettings/NewSoundSettings";
import NewSMS from "./pages/VPBXManager/SMS/NewSMS";
import NewDepartment from "./pages/VPBXManager/Department/NewDepartment";
import UsersAndTeams from "./pages/UsersAndTeams/UsersAndTeams";
import EditHour from "./pages/VPBXManager/Hour/EditHour";
import AddUser from "./pages/UsersAndTeams/Users/AddUser";
import EditUser from "./pages/UsersAndTeams/Users/EditUser";
import Teams from "./pages/UsersAndTeams/Teams/Teams";
import AddTeam from "./pages/UsersAndTeams/Teams/AddTeam";
import SuperAdmin from "./components/SuperAdmin/SuperAdmin";
import AddCompany from "./components/SuperAdmin/Companies/AddCompany";
import CreatePackages from "./components/SuperAdmin/Packages/CreatePackages";
import AddMasterNumberDIOD from "./components/SuperAdmin/MasterNumberDIOD/AddMasterNumberDIOD";
import PrivateRoute from "./Routes/PrivateRoute";
import EditDetailForm from "../src/pages/MyCompany/Deatils/EditDetailForm";
import AddGroup from "./pages/VPBXManager/Group/AddGroup";
import NotFound from "./components/common/NotFound";
import Password from "./pages/Profile/Password";
import Profile from "./pages/Profile/Profile";
import AddQueue from "./pages/VPBXManager/Queue/AddQueue";
import EditQueue from "./pages/VPBXManager/Queue/EditQueue";
import EditTeam from "./pages/UsersAndTeams/Teams/EditTeam";
import Callinitialize from "./pages/CallInitialize/Callinitialize";
import UploadCampaign from "./pages/CallInitialize/UploadCampaign";
import CampaignNumber from "./pages/CallInitialize/CampaignNumber";
import CampaignNumberEdit from "./pages/CallInitialize/CampaignNumberEdit";
import CampaginUpload from "./pages/CallInitialize/CampaginUpload";
import ExtensionsDetails from "./pages/VPBXManager/ExtensionsDetails/ExtensionsDetails";
import CallForwarding from "./pages/VPBXManager/CallForwarding/CallForwarding";
import CallConferencing from "./pages/VPBXManager/CallConferencing/CallConferencing";
import ListManager from "./pages/VPBXManager/ListManager/ListManager";
import UpdatedSoundSetting from "./pages/VPBXManager/SoundSettings/UpdatedSoundSetting";
import Hour from "./pages/VPBXManager/Hour/Hour";
import CustomizedIvr from "./pages/VPBXManager/CustomizedIvr/CustomizedIvr";
import Queue from "./pages/VPBXManager/Queue/Queue";
import Prompts from "./pages/VPBXManager/SoundSettings/Prompts";
import Companies from "./components/SuperAdmin/Companies/Companies";
import Packages from "./components/SuperAdmin/Packages/Packages";
import MasterNumberDIOD from "./components/SuperAdmin/MasterNumberDIOD/MasterNumberDIOD";
import IncomingCalls from "./pages/CallRecords/Incomingcalls";
import OutgoingCalls from "./pages/CallRecords/OutgoingCalls";
import NewIncomingCalls from "./pages/CallRecords/NewIncomingCalls";
import NewOutgoingCalls from "./pages/CallRecords/NewOutgoingCalls";
import MissedCalls from "./pages/CallRecords/MissedCalls";
import NewMissedCalls from "./pages/CallRecords/NewMissedCalls";
import ExtToExt from "./pages/CallRecords/ExtToExt";
import NewExtToExt from "./pages/CallRecords/NewExtToExt";
import Feedback from "./pages/CallRecords/Feedback";
import NewFeedback from "./pages/CallRecords/NewFeedback";
import OutboundSoundSetting from "./pages/Settings/OutboundSoundSetting";
import OutboundCustomizedIvr from "./pages/Settings/OutboundCustomizedIvr";
import Graphs from "./pages/Analytics/Graphs";
import TopAgents from "./pages/Analytics/TopAgents";
import Signup from "./pages/Signup/Signup";
function App() {
  // const [userIsLoggedIn, setUserIsLoggedIn] = useState(true);
  // let inactivityTimer;

  // Function to reset the inactivity timer
  // const resetInactivityTimer = () => {
  //   clearTimeout(inactivityTimer);
  //   inactivityTimer = setTimeout(() => {
  //     // Automatically sign out the user
  //     setUserIsLoggedIn(false);
  //   }, 1 * 60 * 1000); // 2 minutes in milliseconds
  // };

  // Event listeners to reset the inactivity timer
  // useEffect(() => {
  //   resetInactivityTimer();

  //   const activityEvents = ['mousemove', 'keydown', 'click'];

  //   const resetTimerOnActivity = () => {
  //     resetInactivityTimer();
  //   };

  //   activityEvents.forEach((event) => {
  //     window.addEventListener(event, resetTimerOnActivity);
  //   });

  //   return () => {
  //     activityEvents.forEach((event) => {
  //       window.removeEventListener(event, resetTimerOnActivity);
  //     });
  //   };
  // }, []);

  return (
    <>
      {/* {userIsLoggedIn ? ( */}
      <BrowserRouter>
        <AuthProvider>
          <ToastContainer />
          {/* =========================================Login Routes================================================ */}
          <Routes>
            <Route
              path="/"
              element={
                <LoginProtectedRoute>
                  <div>
                    <Login />
                    <Footer fontColor="#FFFFFF" />
                  </div>
                </LoginProtectedRoute>
              }
            />
            <Route
              path="/signup"
              element={
                  <div>
                    <Signup />
                    <Footer fontColor="#FFFFFF" />
                  </div>
              }
            />
            {/* <Route
              path="/forgot-password"
              element={
                <LoginProtectedRoute>
                  <div>
                    <Header />
                    <ForgotPassword /> <Footer />
                  </div>
                </LoginProtectedRoute>
              }
            />
            <Route
              path="/otp"
              element={
                <LoginProtectedRoute>
                  <div>
                    <Header />
                    <Otp /> <Footer />
                  </div>
                </LoginProtectedRoute>
              }
            />
            <Route
              path="/change-password"
              element={
                <LoginProtectedRoute>
                  <div>
                    <Header />
                    <ChangePassword /> <Footer color="#F5F5F5" />
                  </div>
                </LoginProtectedRoute>
              }
            /> */}
            {/* =========================================Private Routes================================================ */}
            <Route
              path="/welcome"
              element={
                <PrivateRoute>
                  <SplashScreen />
                </PrivateRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <Dashboard />
                      </div>
                    </div>
                    {/* <Footer color="#F5F5F5" extraPadding="70px" /> */}
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/call-records"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <CallRecords />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/graphs"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <Graphs />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/top-agents"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <TopAgents />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            {/* <Route
              path="/incoming-calls"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <IncomingCalls />
                        <NewIncomingCalls />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            /> */}
            {/* <Route
              path="/outgoing-calls"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <OutgoingCalls />
                        <NewOutgoingCalls />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            /> */}
            {/* <Route
              path="/missed-calls"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <MissedCalls />
                        <NewMissedCalls />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            /> */}
            {/* <Route
              path="/ext-to-ext"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <ExtToExt />
                        <NewExtToExt />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            /> */}
            {/* <Route
              path="/feedback"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <Feedback />
                        <NewFeedback />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            /> */}

            <Route
              path="/call-initialize"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <Callinitialize />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/campagin-upload/:campagin_id"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <CampaginUpload />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />

            <Route
              path="/campaign_number_edit/:number/:sno"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <CampaignNumberEdit />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />

            <Route
              path="/upload-campaign"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <UploadCampaign />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />

            <Route
              path="/campaign-number/:campaign_id"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <CampaignNumber />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />

            <Route
              path="/vpbx-manager"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <VPBXManagerMain />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/ivr-flow"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <CreateIVR />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/extensions"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <ExtensionsDetails />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/call-forwarding"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <CallForwarding />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/call-conferencing"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <CallConferencing />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/list-manager"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <ListManager />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/sound-setting"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <UpdatedSoundSetting />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/outbound-sound-settings"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <OutboundSoundSetting />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/hour"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <Hour />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/customized-ivr"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <CustomizedIvr />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/outbound-customized-ivr"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <OutboundCustomizedIvr />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/queue"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <Queue />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/prompt"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <Prompts />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/companies"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <Companies />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/packages"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <Packages />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/master-number"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <MasterNumberDIOD />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />

            <Route
              path="/create-ivr"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <CreateIVR />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />

            <Route
              path="/password-change"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <Password />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/update-profile"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <Profile />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />

            <Route
              path="/new-routing"
              element={
                <PrivateRoute permission={["2"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <NewRouting />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/new-routings"
              element={
                <PrivateRoute permission={["3"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <NewRouting />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/add-queue"
              element={
                <PrivateRoute permission={["2"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <AddQueue />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/edit-queue"
              element={
                <PrivateRoute permission={["2"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <EditQueue />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/edit-queues"
              element={
                <PrivateRoute permission={["3"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <EditQueue />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />

            <Route
              path="/new-forwarding"
              element={
                <PrivateRoute permission={["2"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <NewForwarding />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/new-forwardings"
              element={
                <PrivateRoute permission={["3"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <NewForwarding />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />

            <Route
              path="/new-call-conferencing"
              element={
                <PrivateRoute permission={["2"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <NewCallConferencing />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/new-call-conferencings"
              element={
                <PrivateRoute permission={["3"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <NewCallConferencing />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />

            <Route
              // path="/edit-extension/:extension_number"
              path="/edit-extension"
              element={
                <PrivateRoute permission={["2"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <NewExtensionsDetails />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              // path="/edit-extension/:extension_number"
              path="/edit-extensions"
              element={
                <PrivateRoute permission={["3"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <NewExtensionsDetails />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />

            <Route
              path="/new-list-manager"
              element={
                <PrivateRoute permission={["2"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <NewListManager />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/new-list-managers"
              element={
                <PrivateRoute permission={["3"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <NewListManager />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />

            <Route
              path="/new-sound-setting"
              element={
                <PrivateRoute permission={["2"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <NewSoundSettings />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />

            <Route
              path="/new-sms"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <NewSMS />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />

            <Route
              path="/new-department"
              element={
                <PrivateRoute permission={["2"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <NewDepartment />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/new-departmentS"
              element={
                <PrivateRoute permission={["3"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <NewDepartment />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/user"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <UsersAndTeams />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />

            <Route
              path="/add-user"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <AddUser />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />

            <Route
              path="/working-hour-edit"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <EditHour />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />

            <Route
              path="/edit-user/:id/"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <EditUser />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />

            <Route
              path="/404"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">{/* <Sidebar /> */}</div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <NotFound />
                      </div>
                    </div>
                    {/* <Footer color="#F5F5F5" extraPadding="70px" /> */}
                  </div>
                </PrivateRoute>
              }
            />

            <Route
              path="/teams"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <Teams />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />

            <Route
              path="/add-team"
              element={
                <PrivateRoute permission={["2"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <AddTeam />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            {/* <Route
              path="/edit-user"
              element={
                <PrivateRoute permission={["2"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <EditTeam />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            /> */}

            {/* <Route
              path="/my-company"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <MyCompanyMain />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            /> */}

            <Route
              path="/edit-company"
              element={
                <PrivateRoute permission={["1"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <EditDetailForm />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />

            {/* <Route
              path="/edit-working-hour"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <EditWorkingHours />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            /> */}

            {/* <Route
              path="/edit-layer"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <NewIVRLayers />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            /> */}

            <Route
              path="/super-admin"
              element={
                <PrivateRoute>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <SuperAdmin />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />

            <Route
              path="/add-company"
              element={
                <PrivateRoute permission={["1"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <AddCompany />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />

            <Route
              path="/add-packages"
              element={
                <PrivateRoute permission={["1"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <CreatePackages />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />

            <Route
              path="/add-master-number"
              element={
                <PrivateRoute permission={["1"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <AddMasterNumberDIOD />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/add-group"
              element={
                <PrivateRoute permission={["2"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <AddGroup />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/add-groups"
              element={
                <PrivateRoute permission={["3"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <AddGroup />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />

            <Route
              path="/edit-hour"
              element={
                <PrivateRoute permission={["2"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <EditHour />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
            <Route
              path="/edit-hours"
              element={
                <PrivateRoute permission={["3"]}>
                  <div>
                    <div uk-grid="" className="uk-grid">
                      <div className="uk-width-auto">
                        <Sidebar />
                      </div>
                      <div
                        className="uk-width-expand"
                        style={{ paddingLeft: "60px" }}
                      >
                        <EditHour />
                      </div>
                    </div>
                    <Footer color="#F5F5F5" extraPadding="70px" />
                  </div>
                </PrivateRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      {/* ) : ( */}
      {/* <p>User has been automatically signed out due to inactivity.</p> */}
      {/* )} */}
    </>
  );
}

export default App;
